import {Image} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import React, {memo} from 'react'

import {tagToUrl} from '../../lib/tagToUrl'
import type {IconWidgetProps as Props} from '../types'

const image = css`
  margin-inline-end: ${spacing(1.5)};
  margin-inline-start: ${spacing(0.5)};
`

export const IconWidget = memo(
  ({
    config: {
      icon: {image_tag},
    },
  }: Props): React.ReactElement => <Image alt="" className={image} height={32} src={tagToUrl(image_tag)} />,
)
